import React, { Component, Suspense } from 'react';

const EmbedStateOperator = React.lazy(() => import('./EmbedStateOperator'));

export default class EmbedStateWrapper extends Component {
  render() {
    return(
      <div>
        <Suspense fallback={null}>
          <EmbedStateOperator/>
        </Suspense>
      </div>
    );
  }
}
